export default function($rootScope, $http, $q) {
  return {
    fetchProducts() {
      return new $q((resolve, reject) => {
        $http({
            url: 'userConfig/products.json',
            method: 'GET'
          })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject();
          });
      });
    },

    fetchServices() {
      return new $q((resolve, reject) => {
        $http({
            url: 'userConfig/services.json',
            method: 'GET'
          })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject();
          });
      });
    },

    fetchCategories() {
      return new $q((resolve, reject) => {
        $http({
            url: 'adminConfig/categories.json',
            method: 'GET'
          })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject();
          });
      });
    },

    fetchSolutions() {
      return new $q((resolve, reject) => {
        $http({
            url: 'adminConfig/solutions.json',
            method: 'GET'
          })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject();
          })

      });
    },

    init() {

      $q.all([this.fetchCategories(), this.fetchProducts(), this.fetchSolutions(), this.fetchServices()])
        .then(res => {
          $rootScope.categories = res[0].data.categories;
          $rootScope.products = res[1].data.products;
          $rootScope.solutions = res[2].data.solutions;
          $rootScope.services = res[3].data.services;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/getConfiguration.js